/**
 * @fileOverview The main entry point to your standalone. Start editing here.
 */

import React, { useEffect, useState, useRef, useLayoutEffect } from 'react'
import '@ta-interaktiv/semantic-ui/semantic/dist/components/reset.css'
import '@ta-interaktiv/semantic-ui/semantic/dist/components/site.css'
import '@ta-interaktiv/semantic-ui/semantic/dist/components/segment.css'
import '@ta-interaktiv/semantic-ui/semantic/dist/components/container.css'
import '@ta-interaktiv/semantic-ui/semantic/dist/components/header.css'
import '@ta-interaktiv/semantic-ui/semantic/dist/components/image.css'
import '@ta-interaktiv/semantic-ui/semantic/dist/components/list.css'
import '@ta-interaktiv/semantic-ui/semantic/dist/components/grid.css'
import '@ta-interaktiv/semantic-ui/semantic/dist/components/card.css'
import '@ta-interaktiv/semantic-ui/semantic/dist/components/table.css'
import '@ta-interaktiv/semantic-ui/semantic/dist/components/form.css'
import '@ta-interaktiv/semantic-ui/semantic/dist/components/label.css'
import '@ta-interaktiv/semantic-ui/semantic/dist/components/message.css'
import '@ta-interaktiv/semantic-ui/semantic/dist/components/rail.css'
import '@ta-interaktiv/semantic-ui/semantic/dist/components/loader.css'
import '@ta-interaktiv/semantic-ui/semantic/dist/components/dimmer.css'
import '@ta-interaktiv/semantic-ui/semantic/dist/components/placeholder.css'
import '@ta-interaktiv/semantic-ui/semantic/dist/components/input.css'

import './styles.scss'
import { Masthead } from '@ta-interaktiv/react-masthead'
import { Footer } from '@ta-interaktiv/react-footer'
import { ThemeSwitch } from '@ta-interaktiv/react-theme-switch'
import { MiniFortuneChart } from 'components/miniFortuneChart'
import { ProfilesMenu } from 'components/profiles-menu'
import { Ranking } from 'components/ranking'
import { PortraitPicture } from 'components/portraitPicture'
import { MunicipalityChart } from 'components/municipalityChart'
import { ArticleTeasers } from '@ta-interaktiv/react-article-teasers'
import { CSSTransition } from 'react-transition-group'
import smoothscroll from 'smoothscroll-polyfill'
import { formatFortuneSmallSteps } from 'components/misc'
import { Waypoint } from 'react-waypoint'
import listData from '../../../static/data.json'
import { Link } from '@ta-interaktiv/contentbricks'

console.log(listData)
smoothscroll.polyfill()

const ARTICLE_ID = '581344337345'
const TEASERS = ['197903549119', '108293680979', '962194997651']
const isMobile = window.innerWidth < 900

export function AppComponent() {
  const [data, setData] = useState(listData)
  const [isMenuOpen, setIsMenuOpen] = useState(true)

  return (
    <div className='index'>
      <ThemeSwitch />

      <Masthead articleId={ARTICLE_ID} />

      <header className='ui vertical very fitted segment'>
        <div className='ui container'>
          <div className='ta kicker'>Panorama</div>
          <div className='ui header'>
            <h1>
              <span>Les entrepreneurs romands de moins de 40 ans</span>
            </h1>
            <h2>
              Bilan dresse un panorama des sociétés créées ou dirigées par de
              jeunes Romands, qui témoignent de la vitalité du tissu économique.
            </h2>
          </div>
        </div>
      </header>

      <div className='ui vertical very fitted segment'>
        <div className='ui vertical segment'>
          <div className='ui text container'>
            <div className='ta metainfo'>
              <div className='ta author'>
              Un dossier réalisé par la rédaction de Bilan
              </div>
              <div className='ta updated'>Mis à jour le 25 mai 2022</div>
            </div>
            <div className='ta text'>
              <p>
                Pays d’entrepreneurs, la Suisse s’est en tout temps distinguée
                par sa capacité à régénérer son tissu économique. Dans ce
                dossier consacré aux jeunes entrepreneurs de moins de 40 ans,
                nous vous emmenons à la découverte d’une centaine de Romands qui
                ont su prendre des risques pour amener de nouvelles
                propositions, favoriser la compétitivité et l’emploi du pays.
              </p>
              <p>
                Depuis sa création, Bilan relate les aventures économiques qui
                contribuent à la prospérité du pays. Mais il ne faut pas oublier
                son rôle de défricheur. À cet effet, le magazine a lancé un
                appel auprès de son lectorat début mai. Près d’une cinquantaine
                d’entrepreneurs répondant aux critères y ont répondu. Le
                panorama réalisé dans cette édition n’est certes pas exhaustif,
                mais il est appelé à s’enrichir afin de créer un rendez-vous
                annuel qui célèbre les aventures entrepreneuriales et favorise
                les échanges entre ses actrices et ses acteurs.
              </p>
            </div>
            <div className='ui small message'>
            <div className='content'>
                Les entreprises et leur CEO recensés dans ce panorama
                répondent aux critères suivants: avoir moins de 40 ans au 1er
                janvier 2022, un chiffre d’affaires supérieur à un million de
                francs et au moins un employé. La liste, non exhaustive, est
                appelée à s’enrichir ces prochains mois. Pour y participer:{' '}
                <a href='https//www.bilan.ch'>bilan.ch</a>
              </div>
            </div>
          </div>
        </div>
      </div>

      <Waypoint
        bottomOffset='99%'
        onEnter={() => {
          setIsMenuOpen(false)
        }}
        onLeave={() => {
          setIsMenuOpen(true)
        }}
      >
        <div className='list-wrapper' id='profiles-list'>
          <ProfilesMenu
            data={listData}
            handleChange={filteredData => {
              setData(filteredData)
              // window.scroll({
              //   top: document.getElementById('profiles-list').getBoundingClientRect().top + window.scrollY,
              //   behavior: 'smooth'
              // })
            }}
            isOpen={isMenuOpen}
          />
          {data.length > 0 ? (
            <ProfilesTable data={data} />
          ) : (
            <div className='no-result'>Pas de résultat</div>
          )}
        </div>
      </Waypoint>

      <Footer
        mailTo='charles-andre.aymon@bilan.ch'
        locale='fr'
        hidePortfolioTeaser
        title='Comment jugez-vous ce contenu?'
        questions={[
          'Était-il informatif?',
          'La mise en forme vous plaît-elle?'
        ]}
        articleId={ARTICLE_ID}
        credits={[
          ['Textes', 'La Rédaction'],
          [
            'Ont participé à cette opération',
            'Charles-André Aymon, Pamela Beltrame, Ghislaine Bloch, Jean-Philippe Buchs, Luigino Canal, Julien de Weck, Daniel Eskenazi, Erich Gerbi, Matthieu Hoffstetter, Andrea Machalova, Patricia Meunier, Joan Plancade, Dirk Ruschmann, Marat Shargorodsky, Tiffany Terreaux et Mary Vakaridis'
          ],
          ['Conception et réalisation', 'Mathieu Rudaz']
        ]}
      />
    </div>
  )
}

const ProfilesTable = ({ data }) => {
  const [focusedRowId, setFocusedRowId] = useState(null)
  const [rowsData, setRowsData] = useState(null)
  const rowsElements = useRef(new Map())
  const listRef = useRef(null)

  const handleScroll = () => {
    const t =
      listRef.current.getBoundingClientRect().top - window.innerHeight / 2 + 200
    const o = t > 0 ? 0 : Math.abs(t)
    const i = Math.ceil(o / 150)

    if (focusedRowId !== i) {
      setFocusedRowId(state => {
        return {
          past: state ? state.current : 0,
          current: i
        }
      })
    }
    // filteredData[i].isFocused = true
    // setFilteredData([...filteredData])
    // // console.log(rowsElements.current)
  }

  useEffect(() => {
    // window.addEventListener('scroll', handleScroll)

    if (focusedRowId) {
      console.log(focusedRowId.current)
      //   filteredData[focusedRowId.past].isFocused = false
      //   filteredData[focusedRowId.current].isFocused = true
      // setFilteredData([...filteredData])
    }

    return () => {
      // window.removeEventListener('scroll', handleScroll)
    }
  }, [focusedRowId])

  const handleUpdate = x => {
    rowsElements.current.set(x.id, x.top)
  }

  const handleClick = id => {
    const newRowsData = data.map(d => ({ ...d, isOpen: false }))
    newRowsData.find(d => d.id === id).isOpen = true

    // console.log(newRowsData)

    setRowsData(newRowsData)
  }

  useEffect(() => {
    setRowsData(data.map(d => ({ ...d, isOpen: false })))
  }, [data])

  return rowsData ? (
    // <div className='ui link cards' ref={listRef}>
    <div className='people-list' ref={listRef}>
      {rowsData.map((d, i) => {
        const row = (
          <>
            {i % 30 === 0 && i > 0 && (
              <div className='article-teaser'>
                <ArticleTeasers
                  numberOfCards='one'
                  articleIds={[
                    TEASERS[Math.floor(Math.random() * TEASERS.length)]
                  ]}
                />
              </div>
            )}
            {/* <div className='ui card'>
              <div className='image'>
                <img src='/images/avatar2/large/kristy.png' />
              </div>
              <div className='content'>
                <a className='header'>Kristy</a>
                <div className='meta'>
                  <span className='date'>Joined in 2013</span>
                </div>
                <div className='description'>
                  Kristy is an art director living in New York.
                </div>
              </div>
              <div className='extra content'>
                <a>
                  <i className='user icon' />
                  22 Friends
                </a>
              </div>
            </div> */}
            <ProfileRow
              key={`profile-row-${d.id}`}
              data={d}
              handleUpdate={handleUpdate}
              handleClick={handleClick}
              isFocused={d.isFocused}
              isOpen={d.isOpen}
            />
          </>
        )

        return row
      })}
    </div>
  ) : (
    <div className='ui placeholder'>
      <div className='line' />
      <div className='line' />
      <div className='line' />
      <div className='line' />
      <div className='line' />
    </div>
  )
}

const ProfileRow = ({ data, handleUpdate, isFocused, isOpen, handleClick }) => {
  const rowRef = useRef(null)

  const scrollToRow = () => {
    // window.scrollTo(0, window.scrollY - 300)
    // setTimeout(() => {rowRef.current.scrollIntoView()}, 1000)
  }

  useLayoutEffect(() => {
    handleUpdate({
      id: data.id,
      top: rowRef.current.getBoundingClientRect().top,
      height: rowRef.current.getBoundingClientRect().height
    })
  }, [])

  return (
    <div
      className={`content person-row ${isOpen ? 'open' : ''}`}
      key={`person-row-${data.id}`}
      ref={rowRef}
    >
      <div className='over-curtain' />
      <div
        className='person-row-content'
        onClick={() => {
          handleClick(data.id)
          scrollToRow()
        }}
      >
        <div className='ui container' style={{ zIndex: 1 }}>
          <div className='rank'>
            <span />
          </div>
          <div className='content'>
            <div className='ui two columns stackable grid'>
              <div className='column'>
                <a
                  href={`/entrepreneurs-de-moins-de-40-ans/${data.slug}.html`}
                  onClick={e => e.preventDefault()}
                >
                  <div className='profile-container'>
                    <PortraitPicture id={data.image ? data.id : null} />
                    <div className='infos'>
                      {/* <span style={{fontWeight: 200, fontSize: '0.75em'}}>Rang</span> {data.rank} */}
                      <div className='header'>
                        {data.firstname} {data.surname}
                      </div>
                      <div className='residence'>
                        <b>{data.age} ans</b>,{' '}
                        {data.residence.map((n, i) => (
                          <>
                            <span key={`nationality-tag-${n.value}`}>
                              {n.name}
                            </span>
                            {i < data.residence.length - 1 && <span>, </span>}
                          </>
                        ))}
                      </div>
                    </div>
                  </div>
                </a>
              </div>
              <div className='column fortune-col'>
                {/* <div className='fortuneChartContainer'>
                  {data.fortunes.length > 1 && (
                    <MiniFortuneChart data={data.fortunes} />
                  )}
                </div> */}
                <div className='fortune'>
                  {data.businessName}
                  {/* <span>{data.fortuneFrom} à {data.fortuneTo} millions</span>{' '}
                  <i className={`arrow ${data.fortuneEvolution}`} /> */}
                </div>
              </div>
            </div>
          </div>
          <div className='openicon'>
            <div className='open-icon-container'>
              <div className='plus alt' />
            </div>
          </div>
        </div>
        <div className='ui container' style={{ zIndex: 1 }}>
          <div className='content more'>
            <CSSTransition
              in={isOpen}
              timeout={300}
              classNames='more-content-group'
              unmountOnExit
            >
              <>
                <div className='more-content'>
                  <div className='more-infos' style={{marginTop: '1em'}}>
                    <div className='column'>
                      <div className='small-title-profile'>
                        Secteurs d'activité
                      </div>
                      <div>
                        {data.sectors.map(sector => (
                          <span
                            key={`sector-tag-${sector.id}`}
                            className='sector-tag'
                          >
                            {sector.name}
                          </span>
                        ))}
                      </div>
                    </div>

                    {data.markets.length > 0 && (
                      <div className='column'>
                        <div className='small-title-profile'>
                          Principaux marchés
                        </div>
                        {data.markets.map(market => (
                          <span
                            key={`sector-tag-${market.id}`}
                            className='sector-tag'
                          >
                            {market.name}
                          </span>
                        ))}
                      </div>
                    )}
                  </div>

                  <div
                    className='more-infos'
                    style={{ padding: '0', fontWeight: 'bold' }}
                  >
                    {data.keyFigure.length > 5 && (
                      <>

                      <div className='key-figure'>
                      <div className='small-title-profile' style={{marginBottom: '1em', fontSize: '0.55em'}}>
                        Le chiffre clé
                      </div>
                        {data.keyFigure}</div>
                      </>
                    )}
                  </div>
                  <div
                    className='ui very fitted segment center aligned'
                    style={{
                      background: 'transparent',
                      margin: 0,
                      padding: 0,
                      marginTop: '1em'
                    }}
                  >
                    <a
                      className='profile-link-button'
                      href={`/entrepreneurs-de-moins-de-40-ans/${data.slug}.html`}
                      // href={`#/details/${data.slug}`}
                    >
                      <i className='ui icon file alternate outline' />
                      Lire la fiche complète
                    </a>
                  </div>
                </div>
              </>
            </CSSTransition>
          </div>
        </div>
      </div>
    </div>
  )
}
